import { useEffect, useState } from "react";
import useQuickLinks from "../../components/hooks/useQuickLinks";
import { useTheme } from "../../components/hooks/useTheme";
import { CircularProgress } from "@mui/material";
import baseURL from "../../configs/api";
import { iconValues } from "../../utils/iconValues";
import Cookies from "js-cookie";
import useTenant from "../../components/hooks/useTenant";


export const QuickLinks = () => {
  const tenantId = Cookies.get("tenantId-jj-rental-ui") || "";
  const { themeStyles } = useTheme();
  const { handleTenantError }: any = useTenant();
  const { quickLinks, setQuickLinks }: any = useQuickLinks();
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    setLoading(true)
    fetch(`${baseURL}QuickLinks/GetQuickLinksWithActive/true`, {
      method: "GET",
      headers: {
        'X-Tenant-ID': tenantId,
        "Content-Type": "application/json" 
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setQuickLinks(data);
        setLoading(false);
        handleTenantError(null);
      })
      .catch((error) => {
        setQuickLinks([]);
        setLoading(false);      
        handleTenantError(error);
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleLinkClick = (link: string, isNewTab: boolean) => {
    if (isNewTab) {
      window.open(link, '_blank');
    } else {
      window.location.href = link;
    }
  };

  return (
    <div className={`border ${themeStyles.main.borderColor} rounded-[16px] p-4 w-full`}>
      <h2 className={`text-lg font-semibold ${themeStyles.main.textHeadingColor}`}>Quick Links</h2>
      {
        loading && (
          <div className="w-full h-full flex items-center justify-center">
            <CircularProgress />
          </div>
        )
      }

      {
        !loading && (
          <div className="w-full flex flex-wrap mt-2 max-h-[340px] overflow-y-auto">
            {
              quickLinks ? quickLinks?.length > 0 && (
                quickLinks
                  ?.filter((item: any) => item?.isActive)
                  ?.map((item: any, index: number) => {
                    const iconData = iconValues?.find((icon) => icon?.value === item?.topBarIcon);

                    return iconData ? (
                      <div
                        key={index}
                        title={item?.label}
                        className={`group flex flex-col items-center justify-center w-[120px] h-[120px] border shadow-sm gap-y-[0.25rem] p-2 mt-2 mr-2 cursor-pointer ${themeStyles.main.borderColor} rounded-[8px]`}
                        onClick={() => handleLinkClick(item?.link, item?.isOpenInNewTab)}
                      >
                        <span className={`group-hover:scale-125 material-symbols-outlined text-center text-[#167AC3]  text-[40px] font-extralight`}>
                          {iconData?.icon}
                        </span>
                        <span className={`group-hover:font-semibold text-[12px] font-normal text-center line-clamp-1 text-[#167AC3]`}>{item?.label}</span>
                      </div>
                    ) : null

                  })
              ) : (
                <div className="w-full h-full flex items-center justify-center">
                  <span className={`text-xs font-semibold ${themeStyles.main.textSubHeadingColor}`}>No data</span>
                </div>
              )
            }
          </div>
        )
      }
    </div>
  )
}